var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "com-dialog g-certi-dialog",
      attrs: {
        title: "电子数据存证证书",
        visible: _vm.dialogVisible,
        "before-close": _vm.close,
        width: "980px"
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "g-certi-dialog-conent" }, [
        _c("div", { staticClass: "img-certi" }, [
          _vm.certStatus
            ? _c(
                "a",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.certLoading,
                      expression: "certLoading"
                    }
                  ],
                  staticClass: "img-certi-a",
                  attrs: {
                    href: _vm.certUrl,
                    target: "_blank",
                    title: "点击放大"
                  }
                },
                [
                  _c("img", {
                    staticClass: "img-certi-img",
                    attrs: { src: _vm.certUrl },
                    on: {
                      loadstart: function($event) {
                        _vm.certLoading = true
                      },
                      load: function($event) {
                        _vm.certLoading = false
                      }
                    }
                  })
                ]
              )
            : _c(
                "a",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.certLoading,
                      expression: "certLoading"
                    }
                  ],
                  staticStyle: {
                    "min-height": "637px",
                    display: "inline-block"
                  },
                  attrs: { href: "javascript:void(0);", title: "点击刷新" },
                  on: {
                    click: function($event) {
                      return _vm.flushCertStatus()
                    }
                  }
                },
                [
                  _c("img", {
                    attrs: { src: _vm.certUrl },
                    on: {
                      loadstart: function($event) {
                        _vm.certLoading = true
                      },
                      load: function($event) {
                        _vm.certLoading = false
                      }
                    }
                  })
                ]
              )
        ]),
        _c(
          "div",
          { staticClass: "right-btn-warp" },
          [
            _c(
              "el-button",
              {
                staticClass: "g-certi-btn",
                attrs: {
                  id: "tag-copy",
                  "data-clipboard-text": _vm.leftPad(_vm.param.presId, 10, "0"),
                  size: "small"
                },
                on: {
                  click: function($event) {
                    return _vm.copyText($event)
                  }
                }
              },
              [_vm._v("复制备案号\n      ")]
            ),
            _c(
              "el-button",
              {
                staticClass: "g-certi-btn",
                attrs: {
                  id: "tag-copy1",
                  "data-clipboard-text": _vm.param.presId,
                  size: "small"
                },
                on: {
                  click: function($event) {
                    return _vm.copyTextToQuery($event)
                  }
                }
              },
              [_vm._v("复制备案号并查询\n      ")]
            ),
            _c(
              "el-button",
              {
                staticClass: "g-certi-btn",
                attrs: { size: "small" },
                on: {
                  click: function($event) {
                    return _vm.downloadCert(1)
                  }
                }
              },
              [_vm._v("下载图片证书")]
            ),
            _c(
              "el-button",
              {
                staticClass: "g-certi-btn",
                attrs: { size: "small" },
                on: {
                  click: function($event) {
                    return _vm.downloadCert(2)
                  }
                }
              },
              [_vm._v("下载PDF证书")]
            ),
            _c(
              "div",
              { staticStyle: { display: "flex", position: "relative" } },
              [
                _vm.showInput
                  ? _c(
                      "el-button",
                      {
                        staticClass: "g-certi-btn",
                        attrs: { size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.queryIdentification(_vm.param.presId)
                          }
                        }
                      },
                      [_vm._v("获取工信部标识")]
                    )
                  : _c(
                      "el-input",
                      {
                        attrs: { id: "text", size: "medium", readonly: "" },
                        on: { click: _vm.copy },
                        model: {
                          value: _vm.gxbbs,
                          callback: function($$v) {
                            _vm.gxbbs = $$v
                          },
                          expression: "gxbbs"
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-copy-document",
                          staticStyle: { "line-height": "36px" },
                          attrs: { slot: "suffix" },
                          on: { click: _vm.copy },
                          slot: "suffix"
                        })
                      ]
                    ),
                _c(
                  "el-tooltip",
                  { attrs: { effect: "light", placement: "bottom-end" } },
                  [
                    _c("div", { attrs: { slot: "content" }, slot: "content" }, [
                      _vm._v("\n            数据同步需要一定时间，"),
                      _c("br"),
                      _vm._v("可在生成数据后次日查询\n          ")
                    ]),
                    _c("i", {
                      staticClass: "el-icon-question",
                      staticStyle: {
                        "font-size": "16px",
                        "margin-left": "100%",
                        color: "#a1a1a1",
                        cursor: "pointer",
                        position: "absolute"
                      }
                    })
                  ]
                ),
                _c(
                  "a",
                  {
                    staticStyle: {
                      "font-size": "14px",
                      color: "#5091d6",
                      cursor: "pointer",
                      position: "absolute",
                      "margin-top": "10%",
                      "margin-left": "100%",
                      width: "50px"
                    },
                    attrs: { href: "https://dms.citln.cn/", target: "_blank" }
                  },
                  [_vm._v("前往 >")]
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "mini", type: "primary" },
              on: { click: _vm.close }
            },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f23691f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f23691f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/apply-list/certiServiceDialog.vue
// module id = atXa
// module chunks = 23 24 27 29 31 50 60